import '../css'
import Autocomplete from 'bootstrap5-autocomplete'
import Choices from 'choices.js'
import 'choices.js/public/assets/styles/choices.css'

const set_country_division_list = (country_division_id) => {
  const country_id = document.querySelector('#generic_request_country_id').value
  fetch(`/address_verification/country_division_select/${country_id}?t=${new Date().getTime()}`)
    .then(resp => resp.ok && resp.text())
    .then(data => {
      const select = document.querySelector('#generic_request_country_division_id')
      select.innerHTML = data
      select.choices.refresh()

      if (country_division_id) {
        select.choices.setChoiceByValue(`${country_division_id}`)
      }
    })
}

const insertProduct = (id, text) => {
  document.querySelector('#selected_products').insertAdjacentHTML('beforeend', `
    <div class="removeable row row-skinny row-bottom-space">
      <div class="col-md-12">
        <a href="#" class="remove btn btn-sm btn-danger me-2"><i class="fa fa-xmark"></i></a> ${text}
        <input id="generic_request_product_ids_${id}" name="generic_request[product_ids][]" type="hidden" value="${id}">
      </div>
    </div>
  `)
}

addEventListener('turbo:load', () => {
  document.querySelectorAll('select.choices-select').forEach(el => { el.choices = new Choices(el, { placeholderValue: 'Select an option' }) })

  const productOptions = document.querySelector('#product_options')
  if (productOptions) {
    fetch('/generic_requests/products')
      .then(resp => resp.ok && resp.text())
      .then(data => {
        document.querySelector('#products').innerHTML = data
        productOptions.innerHTML = data
        productOptions.choices.refresh()

        document.querySelectorAll('#product_options option[data-default]').forEach(el => {
          insertProduct(el.value, el.innerText)
        })
      })
  }

  const country = document.querySelector('#generic_request_country_id')
  if (country && country.value != '') {
    set_country_division_list(document.querySelector('#generic_request_country_division_id').dataset.id)
  }

  const attn = document.querySelector('#generic_request_attention_care_of')
  if (attn) {
    attn.ac = new Autocomplete(attn, {
      items: {
        'ATTN: ': 'ATTN: ',
        'C/O: ': 'C/O: '
      },
      suggestionsThreshold: 0
    })
  }
})

addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('select.choices-select').forEach(el => { el.choices?.destroy() })
  document.querySelector('#generic_request_attention_care_of')?.ac?.dispose()
})

addEventListener('change', ({ target }) => {
  if (target.matches('.address_field')) {
    document.querySelector('#generic_request_is_verified').value = 'false'
  }

  if (target.matches('#generic_request_country_id')) {
    set_country_division_list()
  }

  if (target.matches('#product_options')) {
    if (target.value == '') return

    if (!document.querySelector(`#selected_products #generic_request_product_ids_${target.value}`)) {
      const { innerText } = target.querySelector('option:checked')
      insertProduct(target.value, innerText)
    }

    target.choices.clearStore()
    target.innerHTML = document.querySelector('#products').innerHTML
    target.choices.refresh()
  }

  if (target.matches('#generic_request_promo_code_id')) {
    const { requestOriginId } = target.querySelector('option:checked').dataset
    const { choices } = document.querySelector('#generic_request_request_origin_id')
    choices.setChoiceByValue(requestOriginId)
  }

  if (target.matches('#generic_request_request_origin_id')) {
    const { choices } = document.querySelector('#generic_request_promo_code_id')
    choices.setChoiceByValue('')
  }
})

addEventListener('click', e => {
  if (e.target.matches('a[id$="-tab"]')) {
    e.preventDefault()

    document.querySelectorAll('a[id$="-tab"]').forEach(el => {
      if (el == e.target) {
        el.classList.remove('btn-outline-primary')
        el.classList.add('btn-primary')
      } else {
        el.classList.remove('btn-primary')
        el.classList.add('btn-outline-primary')
      }
    })
    document.querySelector('#generic_request_contact_type').value = e.target.id.replace('-tab', '')
  }

  if (e.target.closest('.remove')) {
    e.preventDefault()
    e.target.closest('.removeable').remove()
  }
})

addEventListener('keyup', ({ target }) => {
  if (target.matches('#individual_first_name') || target.matches('#organization_first_name')) {
    document.querySelector('#generic_request_first_name').value = target.value
  }
})

addEventListener('addressVerified', ({ target, detail: { country_division_id } }) => {
  if (target.matches('#address_verification_modal')) {
    const country = document.querySelector('#generic_request_country_id')
    country.choices.setChoiceByValue(country.value)
    set_country_division_list(country_division_id)
    target.querySelector('[data-bs-dismiss="modal"]').click()
  }
})
